import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["original", "translated"]

  connect() {
    this.isScrolling = false
    this.originalTarget.addEventListener('scroll', (e) => this.handleScroll(e, 'original'))
    this.translatedTarget.addEventListener('scroll', (e) => this.handleScroll(e, 'translated'))
  }

  handleScroll(event, source) {
    if (this.isScrolling) return
    this.isScrolling = true

    const sourceEl = event.target
    const targetEl = source === 'original' ? this.translatedTarget : this.originalTarget

    // Get all paragraphs in both containers
    const sourceParagraphs = sourceEl.querySelectorAll('.paragraph')
    const targetParagraphs = targetEl.querySelectorAll('.paragraph')

    // Find the first visible paragraph in source
    let firstVisiblePara = null
    let firstVisibleRatio = 0
    sourceParagraphs.forEach(para => {
      const rect = para.getBoundingClientRect()
      const ratio = rect.top / sourceEl.clientHeight
      if (ratio >= 0 && (firstVisiblePara === null || ratio < firstVisibleRatio)) {
        firstVisiblePara = para
        firstVisibleRatio = ratio
      }
    })

    if (firstVisiblePara) {
      // Get corresponding paragraph in target
      const paraId = firstVisiblePara.dataset.paraId
      const targetPara = targetEl.querySelector(`[data-para-id="${paraId}"]`)
      if (targetPara) {
        targetEl.scrollTop = targetPara.offsetTop - (firstVisiblePara.offsetTop - sourceEl.scrollTop)
      }
    }

    setTimeout(() => {
      this.isScrolling = false
    }, 20)
  }
}
